import React from 'react'
import { Typography } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import { GroupsDeviceIcon } from 'icons'
import useStyles from './GroupsButton.style'

const GroupsButton: React.FC = () => {
  const { classes } = useStyles()
  const location = useLocation()
  return (
    <Wrapper className={classes.deviceSettingsContainer}>
      <Link
        to={`${location.pathname}/groups`}
      >
        <Wrapper className={classes.deviceSettingsItem}>
          <Wrapper className={classes.deviceSettingsIcon}>
            <GroupsDeviceIcon />
          </Wrapper>
          <Typography className={classes.deviceSettingsLabel}>Groups</Typography>
        </Wrapper>
      </Link>
    </Wrapper>
  )
}

export default GroupsButton
